export default "__VITE_ASSET__16f16f59__"